/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

//<custom-head>
import { ArticleSpecificInformationDto } from './article-specific-information-dto';
//</custom-head>

export class ClearanceCaseRowSpecificInformationDto {
  public id: number = undefined;
  public specificInformationId: number = undefined;
  public countryCode: string = undefined;
  public data: string = undefined;

  //<custom-body>
  fromArticle(article: ArticleSpecificInformationDto): ClearanceCaseRowSpecificInformationDto {
    this.specificInformationId = article.specificInformationId;
    this.countryCode = article.countryCode;

    return this;
  }
  //</custom-body>
}
